package com.patronat.top.di


import com.arkivanov.decompose.ComponentContext
import com.patronat.top.root.DefaultRootComponent
import org.koin.dsl.module

typealias RootComponentFactory = (ComponentContext) -> DefaultRootComponent

val rootModule = module {
    single<RootComponentFactory> {
        { componentContext ->
            DefaultRootComponent(
                tokenStorage = get(),
                componentContext = componentContext
            )
        }
    }
}